import React from 'react'

import { FormTitleProps } from '../items/FormTitle'
import LinkLine, { LinkLineProps } from '../items/LinkLine'
import BaseGroup from './BaseGroup'

/**
 * アイコン付きリンクグループ
 */
const LinkGroup: React.FC<LinkGroupProps> = (props) => {
  return (
    <BaseGroup
      isRequired={props.isRequired}
      title={props.title}
      description={props.description}
      hideTitle={props.hideTitle}
    >
      {props.links.map((link, index) => (
        <LinkLine {...link} key={index} />
      ))}
    </BaseGroup>
  )
}

export type LinkGroupProps = FormTitleProps & {
  links: Array<LinkLineProps>
}

export default React.memo<LinkGroupProps>(LinkGroup)
